"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMenu = GameMenu;
const React = __importStar(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const ui_1 = require("@creature-chess/ui");
const networking_1 = require("~/networking");
const creatureDefinitions_1 = require("~/networking/creatureDefinitions");
const sessionSources_1 = require("~/networking/sessionSources");
const plugins_1 = require("~/plugins");
const useStyles_1 = require("~/useStyles");
const PageBackground_1 = require("../PageBackground");
const help_1 = require("../game/help");
const CreatureStrip_1 = require("./CreatureStrip");
const MenuSettings_1 = require("./MenuSettings");
const bootEntrance_1 = require("./bootEntrance");
const STRIP_CREATURE_COUNT = 5;
const pickRandomCreatureIds = (count) => {
    const pool = (0, creatureDefinitions_1.getAvailableCreatureIds)();
    for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    return pool.slice(0, count);
};
const NAV_ITEMS = [
    { key: "home", label: "Home", icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faHouse }) },
    { key: "profile", label: "Profile", icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUser }) },
    { key: "help", label: "Help", icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCircleQuestion }) },
];
/**
 * Left-to-right order that the different menu views sit in, for
 * the purpose of determining which direction to slide when switching views.
 */
const VIEW_ORDER = [
    "home",
    "profile",
    "help",
    "updates",
    "settings",
];
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    "root": {
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
    },
    "foreground": {
        position: "absolute",
        inset: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
        padding: "0.5rem",
    },
    "foregroundEntering": {
        // Fades in once the splash logo has finished fading out.
        animation: `$menuFadeIn ${bootEntrance_1.BOOT_MENU_FADE_MS}ms ease ${bootEntrance_1.BOOT_MENU_FADE_DELAY_MS}ms both`,
        // Invisible-but-mounted during the boot entrance: block clicks so the
        // hidden "Quick play" button can't be hit through the splash.
        pointerEvents: "none",
    },
    "@keyframes menuFadeIn": {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    "viewport": {
        position: "relative",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
    },
    "layer": {
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
    },
    "layerCenter": {
        justifyContent: "center",
    },
    "enterRight": { animation: "$slideInRight 300ms ease both" },
    "enterLeft": { animation: "$slideInLeft 300ms ease both" },
    "exitLeft": { animation: "$slideOutLeft 300ms ease both" },
    "exitRight": { animation: "$slideOutRight 300ms ease both" },
    "@keyframes slideInRight": {
        from: { transform: "translateX(calc(100% + 1rem))" },
        to: { transform: "translateX(0)" },
    },
    "@keyframes slideInLeft": {
        from: { transform: "translateX(calc(-100% - 1rem))" },
        to: { transform: "translateX(0)" },
    },
    "@keyframes slideOutLeft": {
        from: { transform: "translateX(0)" },
        to: { transform: "translateX(calc(-100% - 1rem))" },
    },
    "@keyframes slideOutRight": {
        from: { transform: "translateX(0)" },
        to: { transform: "translateX(calc(100% + 1rem))" },
    },
    "card": {
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
        width: "100%",
        maxWidth: "460px",
        margin: "0 auto",
        padding: "1rem",
        boxSizing: "border-box",
        background: theme.palette.surface,
        borderRadius: "0.9rem",
    },
    "body": {
        display: "flex",
        flexDirection: "column",
        gap: "0.75rem",
    },
    "placeholder": {
        color: theme.palette.muted,
        textAlign: "center",
        padding: "2rem 1rem",
        fontSize: "1.2rem",
    },
}));
function MenuAccount({ onClick }) {
    var _a, _b;
    // Never null as the guest source is always available.
    const session = (0, sessionSources_1.useSession)();
    const picture = (_a = session === null || session === void 0 ? void 0 : session.picture) !== null && _a !== void 0 ? _a : null;
    return (React.createElement(ui_1.AccountPill, { name: (_b = session === null || session === void 0 ? void 0 : session.name) !== null && _b !== void 0 ? _b : "Guest", avatar: picture ? React.createElement("img", { src: picture, alt: "" }) : undefined, icon: picture ? undefined : React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faUser }), onClick: onClick }));
}
function GameMenu() {
    var _a, _b;
    const classes = useStyles();
    const socketManager = (0, networking_1.useSocketManager)();
    const entering = React.useContext(bootEntrance_1.BootEntranceContext);
    const [view, setView] = React.useState("home");
    const [prev, setPrev] = React.useState(null);
    const goTo = React.useCallback((next) => {
        if (next === view) {
            return;
        }
        const dir = VIEW_ORDER.indexOf(next) > VIEW_ORDER.indexOf(view) ? 1 : -1;
        setPrev({ view, dir });
        setView(next);
    }, [view]);
    const onPlay = React.useCallback(() => socketManager.connect(), [socketManager]);
    const onShowUpdates = React.useCallback(() => goTo("updates"), [goTo]);
    const creatureIds = React.useMemo(() => pickRandomCreatureIds(STRIP_CREATURE_COUNT), []);
    const navActive = (_b = (_a = NAV_ITEMS.find((item) => item.key === view)) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : null;
    const renderView = (v) => {
        switch (v) {
            case "home":
                return (React.createElement("div", { className: classes.card },
                    React.createElement(CreatureStrip_1.CreatureStrip, { definitionIds: creatureIds }),
                    React.createElement(plugins_1.Region, { cls: "menu-card-body", ctx: { onPlay, onShowUpdates, version: APP_VERSION } },
                        React.createElement("div", { className: classes.body },
                            React.createElement(ui_1.MenuPlayButton, { icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPlay }), title: "Quick play", subtitle: "Casual \u00B7 8 players \u00B7 no account needed", onClick: onPlay }),
                            React.createElement(ui_1.MenuBanner, { icon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faNewspaper }), label: "What's new", suffix: `· patch ${APP_VERSION}`, chevron: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronRight }), onClick: onShowUpdates })))));
            case "profile":
                return (React.createElement(plugins_1.Region, { cls: "menu-profile", ctx: {} },
                    React.createElement(ui_1.Panel, null,
                        React.createElement("div", { className: classes.placeholder }, "Sign in to view your profile."))));
            case "help":
                return (React.createElement(ui_1.Panel, null,
                    React.createElement(help_1.Help, { onBack: () => goTo("home") })));
            case "updates":
                return (React.createElement(ui_1.Panel, null,
                    React.createElement(plugins_1.Region, { cls: "menu-updates", ctx: { onBack: () => goTo("home") } },
                        React.createElement("div", { className: classes.placeholder }, "No update notes."))));
            case "settings":
                return React.createElement(MenuSettings_1.MenuSettings, { onBack: () => goTo("home") });
            default:
                return null;
        }
    };
    const layerClass = (v, anim) => (0, classnames_1.default)(classes.layer, { [classes.layerCenter]: v === "home" || v === "profile" }, anim);
    return (React.createElement("div", { className: classes.root },
        React.createElement(PageBackground_1.PageBoardBackground, null),
        React.createElement("div", { className: (0, classnames_1.default)(classes.foreground, {
                [classes.foregroundEntering]: entering,
            }) },
            React.createElement(ui_1.MenuHeaderBar, { brand: React.createElement("img", { src: `${APP_IMAGE_ROOT}/ui/logo.png`, alt: "Creature Chess Logo" }), account: React.createElement(plugins_1.Region, { cls: "menu-account", ctx: {} },
                    React.createElement(MenuAccount, { onClick: () => goTo("profile") })), settingsIcon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faGear }), onOpenSettings: () => goTo("settings") }),
            React.createElement("div", { className: classes.viewport },
                prev && (React.createElement("div", { key: prev.view, className: layerClass(prev.view, prev.dir === 1 ? classes.exitLeft : classes.exitRight), onAnimationEnd: (e) => {
                        if (e.target === e.currentTarget) {
                            setPrev(null);
                        }
                    } }, renderView(prev.view))),
                React.createElement("div", { key: view, className: layerClass(view, prev
                        ? prev.dir === 1
                            ? classes.enterRight
                            : classes.enterLeft
                        : undefined) }, renderView(view))),
            React.createElement(ui_1.MenuNav, { items: NAV_ITEMS, active: navActive, onSelect: goTo }))));
}
